export const AGREEMENT_TYPES = [
    'product_subscription',
    'managed_services',
    'project',
    'tickets',
];
export const AGREEMENT_TYPE_LABELS = {
    product_subscription: 'Product Subscriptions',
    managed_services: 'Managed Services',
    project: 'Projects',
    tickets: 'Tickets',
};
export const AGREEMENT_STATUSES = ['draft', 'active', 'ended'];
//# sourceMappingURL=agreement.js.map